import { AppThunk } from "../store";
import { fetchInsightsData } from "./defectInsightsThunks";
import { fetchDefectCodes, fetchDefects, setupFilteredDefects } from "./defectThunks";
import { loadGlobalFilterStateEarly } from "./filtersThunks";
import {
    fetchFleetGraph,
    fetchSubgradeBackingData,
    fetchSubgradeData
} from "./fleetGraphThunks";
import {
    fetchInspectionAndGradeData,
    setupFleetData,
    setupFleetStatsData
} from "./fleetThunks";
import { fetchFleetData, fetchShipDetails } from "./listThunks";
import { fetchMetricData } from "./metricThunks";
import { fetchPSCData } from "./pscThunks";
import {
    fetchPreviousRecipients,
    fetchSharedDefects,
    fetchSharedDefectsEvidence
} from "./sharedDefectsThunks";

export const fetchOrder: Record<string, AppThunk[][]> = {
    "": [
        [fetchFleetData()],
        [fetchMetricData(), fetchShipDetails(), fetchDefectCodes()],
        [loadGlobalFilterStateEarly()],
        [fetchInspectionAndGradeData(), fetchSubgradeBackingData()],
        [setupFleetData()],
        [
            fetchSubgradeData()
        ],
        [fetchPreviousRecipients(), fetchFleetGraph()],
        [fetchDefects()],
        [setupFleetStatsData(), setupFilteredDefects(true)],
        [fetchPSCData()],
        [fetchInsightsData()],
        [fetchSharedDefects()], 
        [fetchSharedDefectsEvidence()]
    ],
    grade: [
        [fetchFleetData()],
        [fetchMetricData(), fetchShipDetails(), fetchDefectCodes()],
        [loadGlobalFilterStateEarly()],
        [fetchInspectionAndGradeData(), fetchSubgradeBackingData()],
        [setupFleetData()],
        [fetchFleetGraph()],
        [
            fetchSubgradeData()
        ],
        [fetchPreviousRecipients()],
        [fetchDefects()],
        [setupFleetStatsData(), setupFilteredDefects(true)],
        [fetchPSCData()],
        [fetchInsightsData()],
        [fetchSharedDefects()], 
        [fetchSharedDefectsEvidence()]
    ],
    subgrades: [
        [fetchFleetData()],
        [fetchMetricData(), fetchShipDetails(), fetchDefectCodes()],
        [loadGlobalFilterStateEarly()],
        [fetchInspectionAndGradeData(), fetchSubgradeBackingData()],
        [fetchSubgradeData()],
        [setupFleetData()],
        [fetchFleetGraph(), fetchPreviousRecipients()],
        [fetchDefects()],
        [setupFleetStatsData(), setupFilteredDefects(true)],
        [fetchPSCData()],
        [fetchInsightsData()],
        [fetchSharedDefects()], 
        [fetchSharedDefectsEvidence()]
    ],
    defects: [
        [fetchFleetData()],
        [fetchMetricData(), fetchShipDetails(), fetchDefectCodes()],
        [loadGlobalFilterStateEarly()],
        [fetchInspectionAndGradeData(), fetchSubgradeBackingData()],
        [fetchDefects()],
        [setupFleetData(), setupFilteredDefects(true)],
        [fetchPSCData()],
        [fetchInsightsData()],
        [
            fetchSubgradeData()
        ],
        [fetchPreviousRecipients(), fetchFleetGraph(), setupFleetStatsData()],
        [fetchSharedDefects()], 
        [fetchSharedDefectsEvidence()]
    ],
    psc: [
        [fetchFleetData()],
        [fetchMetricData(), fetchShipDetails(), fetchDefectCodes()],
        [loadGlobalFilterStateEarly()],
        [fetchPSCData(), fetchSubgradeBackingData()],
        [fetchInspectionAndGradeData()],
        [setupFleetData()],
        [fetchPSCData()],
        [
            fetchSubgradeData()
        ],
        [fetchPreviousRecipients(), fetchFleetGraph()],
        [fetchDefects()],
        [setupFleetStatsData(), setupFilteredDefects(true)],
        [fetchInsightsData()],
        [fetchSharedDefects()], 
        [fetchSharedDefectsEvidence()]
    ],
    shareddefects: [
        [fetchSharedDefects()], 
        [fetchSharedDefectsEvidence()]
    ],
    dashboard: [
        [fetchFleetData()],
        [fetchMetricData(), fetchShipDetails(), fetchDefectCodes()],
        [loadGlobalFilterStateEarly()],
        [fetchInspectionAndGradeData(), fetchSubgradeBackingData()],
        [setupFleetData()],
        [
            fetchSubgradeData()
        ],
        [fetchPreviousRecipients(), fetchFleetGraph()],
        [fetchDefects()],
        [setupFleetStatsData(), setupFilteredDefects(true)],
        [fetchPSCData()],
        [fetchInsightsData()],
        [fetchSharedDefects()], 
        [fetchSharedDefectsEvidence()]
    ]
};

export const fetchOrderByList: Record<string, AppThunk[][]> = {
    "": [
        [fetchFleetData()],
        [fetchMetricData(), fetchShipDetails(), fetchDefectCodes()],
        [loadGlobalFilterStateEarly()],
        [fetchInspectionAndGradeData(), fetchSubgradeBackingData()],
        [
            fetchSubgradeData()
        ],
        [
            setupFleetData(),
            fetchFleetGraph(),
        ],
        [fetchDefects()],
        [setupFleetStatsData(), setupFilteredDefects(true)],
        [fetchPSCData()],
        [fetchInsightsData()]
    ],
    grade: [
        [fetchFleetData()],
        [fetchMetricData(), fetchShipDetails(), fetchDefectCodes()],
        [loadGlobalFilterStateEarly()],
        [fetchInspectionAndGradeData(), fetchSubgradeBackingData()],
        [fetchFleetGraph()],
        [
            fetchSubgradeData()
        ],
        [
            setupFleetData(),
            fetchPreviousRecipients(),
        ],
        [fetchDefects()],
        [setupFleetStatsData(), setupFilteredDefects(true)],
        [fetchPSCData()],
        [fetchInsightsData()]
    ],
    subgrades: [
        [fetchFleetData()],
        [fetchMetricData(), fetchShipDetails(), fetchDefectCodes()],
        [loadGlobalFilterStateEarly()],
        [fetchInspectionAndGradeData(), fetchSubgradeBackingData()],
        [
            fetchSubgradeData()
        ],
        [
            setupFleetData(),
            fetchFleetGraph(),
            fetchPreviousRecipients(),
        ],
        [fetchDefects()],
        [setupFleetStatsData(), setupFilteredDefects(true)],
        [fetchPSCData()],
        [fetchInsightsData()]
    ],
    defects: [
        [fetchFleetData()],
        [fetchMetricData(), fetchShipDetails(), fetchDefectCodes()],
        [loadGlobalFilterStateEarly()],
        [fetchInspectionAndGradeData(), fetchSubgradeBackingData()],
        [fetchDefects()],
        [fetchPSCData()],
        [fetchInsightsData()],
        [
            setupFleetData(),
            fetchSubgradeData(),
            fetchPreviousRecipients(),
            setupFilteredDefects(true)
        ],
        [
            fetchFleetGraph(),
            setupFleetStatsData(),
        ]
    ],
    psc: [
        [fetchFleetData()],
        [fetchMetricData(), fetchShipDetails(), fetchDefectCodes()],
        [loadGlobalFilterStateEarly()],
        [fetchPSCData(), fetchSubgradeBackingData()],
        [fetchInspectionAndGradeData()],
        [
            fetchSubgradeData()
        ],
        [
            setupFleetData(),
            fetchFleetGraph(),
        ],
        [fetchDefects()],
        [setupFleetStatsData(), setupFilteredDefects(true)],
        [fetchInsightsData()]
    ],
    dashboard: [
        [fetchFleetData()],
        [fetchMetricData(), fetchShipDetails(), fetchDefectCodes()],
        [loadGlobalFilterStateEarly()],
        [fetchInspectionAndGradeData(), fetchSubgradeBackingData()],
        [setupFleetData()],
        [
            fetchSubgradeData()
        ],
        [fetchPreviousRecipients(), fetchFleetGraph()],
        [fetchDefects()],
        [setupFleetStatsData(), setupFilteredDefects(true)],
        [fetchPSCData()],
        [fetchInsightsData()]
    ],
    shareddefects: [
        [fetchSharedDefects()], 
        [fetchSharedDefectsEvidence()]
    ]
};
